var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.6479C24 6.02053 18.6274 0.647949 12 0.647949C5.37258 0.647949 0 6.02053 0 12.6479C0 18.6374 4.3882 23.6019 10.125 24.5022V16.1167H7.07812V12.6479H10.125V10.0042C10.125 6.9967 11.9166 5.33545 14.6576 5.33545C15.9701 5.33545 17.3438 5.56982 17.3438 5.56982V8.52295H15.8306C14.34 8.52295 13.875 9.44803 13.875 10.3979V12.6479H17.2031L16.6711 16.1167H13.875V24.5022C19.6118 23.6019 24 18.6374 24 12.6479Z",
    fill: "#A4A7AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.647949)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e496f8becda35f5b226de0220429f1b1.svg";
export { ForwardRef as ReactComponent };